import { Action } from '@ngrx/store';
import * as models from '../../domain/models';

export const GET_FLIGHT_CONTRACT_PDF = '[Sourcing.FlightContract] Get Flight Contract PDF';
export const GET_FLIGHT_CONTRACT_PDF_SUCCESS = '[Sourcing.FlightContract] Get Flight Contract PDF Success';
export const GET_FLIGHT_CONTRACT_PDF_FAIL = '[Sourcing.FlightContract] Get Flight Contract PDF Fail';

export const GET_CREDITS = '[Sourcing.FlightContract] Get Credits';
export const GET_CREDITS_SUCCESS = '[Sourcing.FlightContract] Get Credits Success';
export const GET_CREDITS_FAIL = '[Sourcing.FlightContract] Get Credits Fail';

export const GET_PAYMENT_TYPES = '[Sourcing.FlightContract] Get Payment Types';
export const GET_PAYMENT_TYPES_SUCCESS = '[Sourcing.FlightContract] Get Payment Types Success';
export const GET_PAYMENT_TYPES_FAIL = '[Sourcing.FlightContract] Get Payment Types Fail';

export const SUBMIT_CONTRACT = '[Sourcing.FlightContract] Submit Contract';
export const SUBMIT_CONTRACT_SUCCESS = '[Sourcing.FlightContract] Submit Contract Success';
export const SUBMIT_CONTRACT_FAIL = '[Sourcing.FlightContract] Submit Contract Fail';
export const RESET_SUBMIT_CONTRACT_STATE = '[Sourcing.FlightContract] Reset Submit Contract State';

export class GetFlightContractPdfPayload {
  constructor(
    public offerId: string,
    public userLoyaltyCredit: boolean,
    public sourcingRequestId: string) {}
}

export class GetFlightContractPdf implements Action {
  readonly type = GET_FLIGHT_CONTRACT_PDF;

  constructor(public payload: GetFlightContractPdfPayload) { }
}

export class GetFlightContractPdfSuccess implements Action {
  readonly type = GET_FLIGHT_CONTRACT_PDF_SUCCESS;
}

export class GetFlightContractPdfFail implements Action {
  readonly type = GET_FLIGHT_CONTRACT_PDF_FAIL;
}

export class GetCreditsPayload {
  constructor(public offerId: string) { }
}

export class GetCredits implements Action {
  readonly type = GET_CREDITS;

  constructor(public payload: GetCreditsPayload) { }
}

export class GetCreditsSuccess implements Action {
  readonly type = GET_CREDITS_SUCCESS;

  constructor(public payload: models.Credits) { }
}

export class GetCreditsFail implements Action {
  readonly type = GET_CREDITS_FAIL;
}

export class GetPaymentTypesPayload {
  constructor(public clientId: number) {}
}

export class GetPaymentTypes implements Action {
  readonly type = GET_PAYMENT_TYPES;

  constructor(public payload: GetPaymentTypesPayload) {}
}

export class GetPaymentTypesSuccess implements Action {
  readonly type = GET_PAYMENT_TYPES_SUCCESS;

  constructor(public payload: models.OfferContractPaymentType[]) {}
}

export class GetPaymentTypesFail implements Action {
  readonly type = GET_PAYMENT_TYPES_FAIL;
}

export class SubmitContractPayload {
  constructor(
    public offerId: string,
    public contractSigned: boolean,
    public contractUploaded: boolean,
    public paymentTypeId: number,
    public amount: number
  ) { }
}

export class SubmitContract implements Action {
  readonly type = SUBMIT_CONTRACT;

  constructor(public payload: SubmitContractPayload) { }
}

export class SubmitContractSuccess implements Action {
  readonly type = SUBMIT_CONTRACT_SUCCESS;
}

export class SubmitContractFail implements Action {
  readonly type = SUBMIT_CONTRACT_FAIL;

  constructor(public payload: string) {}
}

export class ResetSubmitContractState implements Action {
  readonly type = RESET_SUBMIT_CONTRACT_STATE;
}

export type Actions =
  | GetFlightContractPdf
  | GetFlightContractPdfSuccess
  | GetFlightContractPdfFail
  | GetCredits
  | GetCreditsSuccess
  | GetCreditsFail
  | GetPaymentTypes
  | GetPaymentTypesSuccess
  | GetPaymentTypesFail
  | SubmitContract
  | SubmitContractSuccess
  | SubmitContractFail
  | ResetSubmitContractState;
